function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 8,
  fill: "#CCE6D8"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#2B9D8B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.636
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.455 26v-6.222M8.455 16.222V10M15 26v-8M15 14.444V10M21.545 26v-4.444M21.545 18v-8M6 19.778h4.909M12.545 14.444h4.91M19.091 21.556H24"
})), /*#__PURE__*/React.createElement("circle", {
  fill: "#E15D29",
  cx: 22,
  cy: 11,
  r: 4
}));

function SvgFilterWithBadge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterWithBadge);
export default __webpack_public_path__ + "static/media/filter_with_badge.5e5f31e8.svg";
export { ForwardRef as ReactComponent };